import { useSuperMutation, useSuperQuery } from '@vadiun/react-hooks-legacy';
import { useTransferReservationToValidateCount } from 'app/viaje/viajeTraslado/pendienteValidacion/context/TransferReservationToValidateCountContext';
import { useViajesTraslado } from 'app/viaje/services';
import { 
  useDistanceAndPriceTransferReservationClientBusinessCalculator,
  TravelEstimationResult
} from 'app/viaje/services/distanceAndPriceViajeTrasladoCalculator';
import { ReservaTrasladoFormWrapper } from 'app/viaje/viajeTraslado/viajeTraslado/components/ViajeTrasladoFormWrapper';
import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';
import { useHistory, useParams } from 'react-router-dom';
import { Card } from 'shared/components';
import { TransferReservationSingleForm } from '../../viajeTraslado/forms/single/TransferReservationSingleForm';
import {
  transferReservationSingleFormBuilder,
  TransferReservationSingleFormType
} from '../../viajeTraslado/forms/single/TransferReservationSingleFormType';
import { useTransferReservationFormRepository } from '../../viajeTraslado/services/TransferReservationFormRepository';
import { ViajeTrasladoTipoServicio } from '../../viajeTraslado/models';

export const TransferReservationClientBusinessToValidateModifyPage = () => {
  const history = useHistory();
  const params = useParams<{ id: string }>();
  const formRepo = useTransferReservationFormRepository();
  const ViajeTrasladoService = useViajesTraslado();
  const { calculateDistanceAndCost } =
    useDistanceAndPriceTransferReservationClientBusinessCalculator();

  const { invalidateTransferReservationToValidateCount } =
    useTransferReservationToValidateCount();
  const editTrasladoMutation = useSuperMutation(
    ViajeTrasladoService.approveTransferReservationToValidate,
    { showSpinner: true }
  );

  const formValueQuery = useSuperQuery(
    () => formRepo.getToValidate(Number(params.id)),
    {
      showSpinner: true
    }
  );

  async function createViajeTraslado(
    trasladoFormValues: TransferReservationSingleFormType
  ) {
    const ViajeTraslado =
      transferReservationSingleFormBuilder.toModel(trasladoFormValues);
    await editTrasladoMutation.mutate(ViajeTraslado, formValueQuery.data!.id);
    invalidateTransferReservationToValidateCount();
    history.push('/main/operations/coordination/pending-trips');
  }

  function estimatePrice(
    trasladoFormValues: TransferReservationSingleFormType,
    clientBusinessId: number
  ): Promise<TravelEstimationResult[]> {
    if (trasladoFormValues.tipoServicio === ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES) {
      return Promise.resolve([{
        isServiceGrupal: true,
        viajeIndex: 1,
        message: `Es Servicio Grupal*`
      }]);
    }

    return calculateDistanceAndCost(
      {
        arrivalDate: trasladoFormValues.fechaYHoraDeLlegada,
        hasOutSite: trasladoFormValues.hasOutSite,
        points: trasladoFormValues.puntos.map((p) => ({
          lat: p.domicilio.latitud,
          lng: p.domicilio.longitud,
          minutesWaiting: Number(p.espera)
        })),
        serviceType: trasladoFormValues.tipoServicio,
        rateName: trasladoFormValues.fixedRate?.name,
        payWithCash: trasladoFormValues.pay_with_cash,
        entryChannel: trasladoFormValues.canalIngreso
      },
      clientBusinessId
    ).then(result => [result]);
  }

  return (
    <>
      <PageHeader title="Validación" />
      <PageContainer>
        <Card className="w-full" title="Validar traslado">
          <div className="p-8">
            <ReservaTrasladoFormWrapper<TransferReservationSingleFormType>
              onSubmit={createViajeTraslado}
              initialValues={formValueQuery.data!}
              calculateDistanceAndCost={estimatePrice}
            >
              {(params) => (
                <TransferReservationSingleForm {...params} isValidation />
              )}
            </ReservaTrasladoFormWrapper>
          </div>
        </Card>
      </PageContainer>
    </>
  );
};
